<template>
  <BaseViewComponent
    name="call-to-action"
    :is-preview="isPreview"
  >
    <div class="bg-gradient call-to-action-wrapper">
      <div class="container flex no-wrap">
        <div class="left q-mt-lg">
          <div class="title-h2 q-mb-sm">
            {{ pageData.callToActionTitle }}
          </div>
          <div class="text-p">
            {{ pageData.callToActionDescription }}
          </div>
          <div class="flex items-center q-mb-lg q-mt-md">
            <BaseButton
              :label="pageData.callToActionButtonText"
              :url="pageData.callToActionButtonUrl"
            />
          </div>
        </div>
        <div class="right q-mt-lg text-center overflow-hidden flex justify-center">
          <img
            :src="getCompressImage(callToActionImage)"
            class="cover q-ml-md"
          >
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseButton from 'components/book-landing/render/BaseButton.vue';
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const {
  callToActionImage,
} = useBookPageEdit();

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
.cover {
  height: 400px;
  width: auto;
}
</style>
